import './Offline.css';

import { IonCard, IonCardContent, IonItem, IonLabel, IonRadio, IonSelectOption, IonText, useIonToast } from '@ionic/react';
import { barcodeOutline, calendarOutline, cardOutline, phonePortraitOutline, sendOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';

import ActionButton from '../../../components/button/ActionButton';
import InputItem from '../../../components/input/InputItem';
import SlideContent from '../../../components/slide-content/SlideContent';
import { DataProvider } from '../../../library/DataProvider';
import { DepositPostAction } from '../../../redux/actions/Account';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import RadioItem from '../../../components/radio/RadioItem';

interface Props {
    auth: boolean
}

const Offline: React.FC<Props> = (props) => {
    const [toast, dismiss] = useIonToast();

    const dispatch = useAppDispatch()
    const { form_loading, resp } = useAppSelector(state => state.depositPost)

    let formVars;
    
    if (props.auth) {
        formVars = {
            amount: { value: "", validation: { required: true }, error: "" },
            tracking_code: { value: "", validation: { required: true }, error: "" },
            card_number: { value: "", validation: { required: false }, error: "" },
            date: { value: "", validation: { required: true }, error: "" },
            transfer_type: { value: "", validation: { required: true }, error: "" }
        }
    } else {
        formVars = {
            mobile: { value: "", validation: { required: true }, error: "" },
            amount: { value: "", validation: { required: true }, error: "" },
            tracking_code: { value: "", validation: { required: true }, error: "" },
            card_number: { value: "", validation: { required: false }, error: "" },
            date: { value: "", validation: { required: true }, error: "" },
            transfer_type: { value: "", validation: { required: true }, error: "" }
        }
    }

    const [form, setForm] = useState(formVars);

    const [formProvider] = useState(() => new DataProvider(form, setForm));

    const formSubmitHandler = (e: any) => {
        e.preventDefault();

        let formValidation = formProvider.validation(form);

        if (formValidation) {
            dispatch(DepositPostAction(form.amount.value.replace(/\D+/g, ''), form.tracking_code.value, form.card_number.value, form.date.value, form.transfer_type.value))
        }
    }

    useEffect(() => {
        const formDone = () => {
            if (resp != null && !form_loading) {
                if (resp.result) {
                    toast({ message: resp.message, duration: 2000, color: "primary" })

                    formProvider.reset();
                } else {
                    toast({ message: resp.message, duration: 2000, color: "danger" })
                }
            }
        }

        formDone();
    }, [form_loading])

    return <SlideContent type="segment">
        <IonCard>
            <IonCardContent>
                <div className="monthly-pay-offline">
                    <div className="accounts">
                        <IonItem>
                            <IonText className="header">حساب های زیر به نام نذرطبیعت وطن ما</IonText>
                        </IonItem>
                        <IonItem>
                            <IonLabel color="medium">شماره کارت</IonLabel>
                            <IonText>5041727010029716</IonText>
                        </IonItem>
                        <IonItem>
                            <IonLabel color="medium">شماره حساب</IonLabel>
                            <IonText>بانک رسالت 6450907</IonText>
                        </IonItem>
                        <IonItem>
                            <IonLabel color="medium">شماره شبا</IonLabel>
                            <IonText>IR 72700001000226450907001</IonText>
                        </IonItem>
                        <IonItem>
                            <IonLabel color="medium">کد USSD</IonLabel>
                            <IonText className="ltr">*780*5077#</IonText>
                        </IonItem>
                    </div>

                    <form onSubmit={formSubmitHandler}>
                        {!props.auth ?
                            <InputItem name="mobile" type="tel" label="تلفن همراه" icon={phonePortraitOutline} maxlength={15} ltr spaced provider={formProvider} /> : null}

                        <InputItem name="amount" type="number" label="مبلغ واریزی" icon={cardOutline} maxlength={15} ltr spaced provider={formProvider} />

                        <InputItem name="tracking_code" type="tel" label="کد پیگیری" icon={barcodeOutline} maxlength={30} ltr spaced provider={formProvider} />

                        <InputItem name="card_number" type="tel" label="چهار رقم آخر شماره کارت" icon={cardOutline} maxlength={4} ltr spaced provider={formProvider} />

                        <InputItem name="date" type="datepicker" dateType="current" label="تاریخ واریز" icon={calendarOutline} maxlength={10} provider={formProvider} ltr spaced />

                        <InputItem name="transfer_type" type="select2" label="نحوه انتقال" icon={sendOutline} provider={formProvider}>
                            <RadioItem value="card" label='کارت به کارت'/>
                            <RadioItem value="account" label='انتقال به حساب'/>
                            <RadioItem value="ussd" label='کد USSD'/>
                            <RadioItem value="paypal" label='PAYPAL'/>
                        </InputItem>

                        <ActionButton text="ارسال مشخصات واریزی" loading={form_loading} />
                    </form>
                </div>
            </IonCardContent>
        </IonCard>
    </SlideContent>
}

export default Offline